import ApiService from 'config/apiServiceApiGateway'
import * as ApiOldService from 'config/apiServiceConfig'
import {
  HubFeatureFlagType,
  StaffManagementRoleType,
  StaffManagementType,
  SupplyOrderInboundHubProcessInterface,
} from '../@types/CheckQuantity'

type GetAccountInternalFeatureFlagByLocationResponseType = {
  hub_feature_flags: HubFeatureFlagType[]
}

type GetAccountInternalFeatureFlagByLocationParamsType = {
  feature_flag_device: number
  location_id: number
}

export type GetInboundCheckQuantityParamsType = {
  search_product?: string
}

export type PostSubmitSoInboundItemsPayloadType = {
  input_type: string
  manual_reason_id?: number
  package_id: string
  items: {
    actual_quantity: number
    item_ids: number[]
    invalid_items: {
      chronology: Nullable<string>
      evidence_image_url: Nullable<string>
      quantity: number
      status: number
      status_note_id: number
    }[]
  }[]
}

export type GetStaffManagementResponseType = {
  data: StaffManagementType[]
}

export type PostSupplyOrderInboundHubPutawayPayloadType = {
  status: 'CREATE' | 'COMPLETE'
  supplyOrderItemIdList: number[]
  hubStaffIdList: Nullable<number[]>
}

export interface PostCompleteSupplyOrderInboundProcessPayloadInterface {
  supply_order_id: number
  input_type: 'SCAN' | 'MANUAL'
  manual_reason_id: Nullable<number>
  items: {
    supply_order_item_ids: number[]
    actual_quantity: number
    invalid_items: {
      status: number
      status_note_id: number
      quantity: number
      evidence_image_url?: string
      chronology?: string
    }[]
  }[]
}

interface SupplyOrderInboundItemDetailsPayloadInterface {
  ids: number[]
}

export interface SupplyOrderInboundItemDetailsRackPayloadInterface
  extends SupplyOrderInboundItemDetailsPayloadInterface {
  product_rack_id: number
  destination_location_id: number
}

export interface SupplyOrderInboundItemDetailsExpiredDatePayloadInterface
  extends SupplyOrderInboundItemDetailsPayloadInterface {
  expiry_date: string
}
export type PatchSupplyOrderInboundItemDetailsPayloadType =
  | SupplyOrderInboundItemDetailsRackPayloadInterface
  | SupplyOrderInboundItemDetailsExpiredDatePayloadInterface

export interface PostSupplyOrderInboundItemDetailsDeletePayloadInterface {
  so_item_detail_ids: number[]
}

export const getAccountInternalFeatureFlagByLocationApi = (
  params: GetAccountInternalFeatureFlagByLocationParamsType,
) =>
  ApiService.Get<GetAccountInternalFeatureFlagByLocationResponseType>({
    url: '/accounts/internal/v1/hub-feature/device/location',
    params,
  })

export const getInboundCheckQuantityApi = (
  supplyOrderID: number,
  params: GetInboundCheckQuantityParamsType,
) =>
  ApiService.Get({
    url: '/wims/internal/v1/supply-orders/:supplyOrderID/inbound/check-quantity',
    urlParams: { supplyOrderID },
    params,
  })

export const postSubmitSoInboundItemsApi = (
  soId: number,
  payload: PostSubmitSoInboundItemsPayloadType,
) =>
  ApiService.Post({
    url: '/wims/internal/v1/supply-orders/:soId/inbound/items',
    urlParams: { soId },
    data: payload,
  })

export const putSubmitSoInboundCompletedApi = (soId: number) =>
  ApiService.Put({
    url: '/wims/internal/v1/supply-orders/:soId/inbound',
    urlParams: { soId },
  })

export const deleteInboundItemsApi = (params: string) =>
  ApiService.Delete<{ message: string }, true>({
    url: `/wims/internal/v1/supply-orders/inbound/item-details${params}`,
  })

export const getStaffManagement = (locationId: number, role: StaffManagementRoleType) =>
  ApiOldService.Get<GetStaffManagementResponseType>({
    url: `/api/staff-management/staff/:locationId/:role`,
    urlParams: { locationId, role },
  })

export const getSupplyOrderInboundHubProcessApi = (supplyOrderId: number) =>
  ApiService.Get<SupplyOrderInboundHubProcessInterface>({
    url: '/wims/internal/:version/supply-order-inbounds/:supplyOrderId/check-quantity',
    version: 'v1',
    urlParams: { supplyOrderId },
    // config: {
    //   // TODO: remove this config (mock)
    //   baseURL: 'https://c1c52505-a29c-443f-b121-ae77eef9e914.mock.pstmn.io',
    // },
  })

export const postSupplyOrderInboundHubPutaway = (
  payload: PostSupplyOrderInboundHubPutawayPayloadType,
) => {
  const { status, ...data } = payload

  return ApiOldService.Post({
    url: '/api/inbound-grand/putaway/:status',
    urlParams: { status },
    data,
  })
}

export const postCompleteSupplyOrderInboundProcessApi = (
  supplyOrderId: number,
  payload: PostCompleteSupplyOrderInboundProcessPayloadInterface,
) =>
  ApiService.Post<{ message: string }, true>({
    url: '/wims/internal/v1/supply-order-inbounds/:supplyOrderId/items',
    urlParams: { supplyOrderId },
    data: payload,
  })

export const patchSupplyOrderInboundItemDetailsApi = (
  payload: PatchSupplyOrderInboundItemDetailsPayloadType,
) =>
  ApiService.Patch<{ message: string }, true>({
    url: '/wims/internal/v1/supply-order-inbound-item-details',
    data: payload,
  })

export const postSupplyOrderInboundItemDetailsDeleteApi = (
  payload: PostSupplyOrderInboundItemDetailsDeletePayloadInterface,
) =>
  ApiService.Post<{ message: string }, true>({
    url: '/wims/internal/v1/supply-order-inbound-item-details/bulk-deletion',
    data: payload,
  })

export const patchCompleteSupplyOrderInboundHubApi = async (supplyOrderId: number) =>
  ApiService.Patch({
    url: '/wims/internal/v1/supply-orders/:supplyOrderId:completeInboundHub',
    urlParams: { supplyOrderId },
  })
